import { ActiveTrial, AloftDate } from '@aloft/toolkit-shared';

export function getTrialEndMessage(subscription: ActiveTrial): string {
  const daysUntilTrialEnd = subscription.trialEnd.differenceInCalendarDays(AloftDate.today());

  return `Your free trial ends in ${daysUntilTrialEnd.toLocaleString()} ${daysUntilTrialEnd === 1 ? 'day' : 'days'}.`;
}
